export type HighlightVideo = {
        title: string;
        description: string;
        videoUrl?: string;
        youtubeId?: string;
        posterUrl?: string;
};

export const highlightVideos: HighlightVideo[] = [
        {
                title: "Teleop Demo - Dual-Arm Reach",
                description: "Operator-to-robot mapping with rapid shoulder-elbow-wrist alignment feedback.",
                videoUrl: "https://rawcdn.githack.com/sew-geometric-teleop/assets/main/videos/teleop_dual_arm.mp4"
        },
        {
                title: "Fine Manipulation - SEW Constraints",
                description: "SEW can directly convert MMD dancing data to robot motions.",
                videoUrl: "https://rawcdn.githack.com/sew-geometric-teleop/assets/main/videos/fine_manipulation.mp4"
        },
        {
                title: 'SEW-MIMIC generalizes to whole-body retargeting.',
                // description: "SEW can directly convert MMD dancing data to robot motions in real-time.",
                youtubeId: "ciZtzYhyv_E"
        }
];
